import React from "react";

function RepostIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.004"
      height="24"
      viewBox="0 0 14.004 24"
    >
      <g
        id="Group_26861"
        data-name="Group 26861"
        transform="translate(-12271.271 2246)"
      >
        <path
          id="Path_18878"
          data-name="Path 18878"
          d="M5,9.331v7.877H6.75V11.081h8.9L12.2,14.538l1.238,1.238L19,10.206l-5.57-5.57L12.2,5.874l3.457,3.457Z"
          transform="translate(12266.271 -2250.636)"
          fill="#fff"
        />
        <path
          id="Path_18882"
          data-name="Path 18882"
          d="M19,12.513V4.636h-1.75v6.126H8.35l3.457-3.457L10.569,6.068,5,11.638l5.57,5.57,1.238-1.238L8.35,12.513Z"
          transform="translate(12266.271 -2239.208)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default RepostIcon;
